// extracted by mini-css-extract-plugin
export var active = "_5z-7";
export var container = "_5z-0";
export var evenWidth = "_5z-4";
export var large = "_5z-5";
export var outlet = "_5z-8";
export var slide = "_5z-2";
export var small = "_5z-6";
export var tab = "_5z-3";
export var tabs = "_5z-1";